module.exports = __webpack_public_path__ + "img/favicon.cca3581f.svg";